export default "__VITE_ASSET__9f04f16b__"